import React from 'react'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import { getPlural, pluralizeToString } from 'lib/string/pluralize'
import type { OfferPageMultiRoomAutoselectionReason, OfferPageMultiRoomMode, OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MultiRoomModeToggle from '../MultiRoomModeToggle'
import PreSelectionBanner from '../PreSelectionBanner'
import InvalidSelectionBanner from '../InvalidSelectionBanner'
import PriceModeSelectMobile from 'components/OfferPage/Filters/PriceModeSelect/PriceModeSelectMobile'
import Group from 'components/utils/Group'

export const ROOM_MODE_TOGGLE_SECTION_ID = 'roomModeToggleSection'

interface Props {
  roomMode?: OfferPageMultiRoomMode
  rooms: Array<OfferPageRoom>
  saleUnit: string
  autoselectionReason?: OfferPageMultiRoomAutoselectionReason
  charterBundleRoute?: App.CharterBundleRoute
  withHeading?: boolean
}

function OfferPageRoomModeToggleSection({
  roomMode = 'individual',
  rooms,
  saleUnit,
  autoselectionReason,
  charterBundleRoute,
  withHeading = true,
}: Props) {
  const roomsAreSelected = rooms.some(room => room.roomId)
  const showPreSelectionBanner = roomsAreSelected && roomMode === 'individual' && autoselectionReason === 'initial-selection'
  const showInvalidSelectionBanner = roomsAreSelected && roomMode === 'individual' && autoselectionReason === 'invalid-selections'

  return <Pane padding="20 20 16" id={ROOM_MODE_TOGGLE_SECTION_ID}>
    <Group direction="vertical" gap={16}>
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" noDisplayWhenEmpty>
        {/* TODO: i18n — "Select your " has trailing space before dynamic pluralized saleUnit */}
        {withHeading && <Heading variant="heading4">Select your {rooms.length > 1 ? pluralizeToString(saleUnit, rooms.length) : saleUnit}</Heading>}
        {!!charterBundleRoute && <PriceModeSelectMobile />}
      </Group>
      <VerticalSpacer gap={12}>
        <BodyText variant="medium">
          {/* TODO: i18n — trailing/leading spaces in fragments around dynamic saleUnit variables */}
          Choose the same package for all {getPlural(saleUnit)}, or customise each {saleUnit} individually.
        </BodyText>
        <MultiRoomModeToggle inputsName="room-mode-mobile" />
      </VerticalSpacer>
      {showPreSelectionBanner && <PreSelectionBanner saleUnit={saleUnit} />}
      {showInvalidSelectionBanner && <InvalidSelectionBanner saleUnit={saleUnit} />}
    </Group>
  </Pane>
}

export default OfferPageRoomModeToggleSection
